import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, ZapIcon, ClockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  return <section className="py-16 px-4 md:py-24 bg-[#F5F5F5]" data-id="element-74">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-76">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-gray-900 mb-4" data-id="element-77">
            ¿Seguís esperando el{' '}
            <span className="text-[#00A86B]" data-id="element-78">momento perfecto</span>?
          </h2>

          <p className="text-gray-700 text-lg mb-10" data-id="element-79">
            Tu Air Fryer te está esperando. Empezá hoy.{' '}
            <span className="text-[#00A86B] font-bold" data-id="element-80">Tu salud</span> te lo va
            a agradecer.
          </p>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-orange-50 mb-8 text-left max-w-sm mx-auto" data-id="element-81">
            <ul className="space-y-4" data-id="element-82">
              <li className="flex items-start gap-3" data-id="element-83">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-84">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-85" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-86">
                  40 Recetas Keto para Air Fryer Para Principiantes
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-87">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-88">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-89" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-90">
                  Plan Keto 14 Días (BONUS)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-91">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-92">
                  <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-93" />
                </div>
                <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-94">
                  Untables Keto (BONUS)
                </span>
              </li>
            </ul>
          </div>

          <div className="mb-8" data-id="element-95">
            <p className="font-bold text-gray-900 mb-1" data-id="element-96">SOLO POR</p>
            <PriceDisplay amount={9000} className="font-heading font-extrabold text-[52px] text-[#00A86B] leading-none" data-id="element-97" />
          </div>

          <div className="w-full mb-6" data-id="element-98">
            <CTAButton data-id="element-99">QUIERO TRANSFORMAR MI ALIMENTACIÓN →</CTAButton>
          </div>

          <div className="flex justify-center gap-4 text-xs text-gray-600 font-medium" data-id="element-100">
            <div className="flex items-center gap-1" data-id="element-101">
              <LockIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-102" />
              <span data-id="element-103">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-104">
              <ZapIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-105" />
              <span data-id="element-106">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-107">
              <ClockIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-108" />
              <span data-id="element-109">Oferta solo por hoy</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}